import eventBus, { OPEN_SNACKBAR, openConfirmDialog } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';
import locationBatchJobsService from '@/api/locations-batch-jobs-service';


const state = {
  locations: null,
  locationsBatchJob: null,
  batchJobValidationErrors: {}
};

const mutations = {
  SET_LOCATIONS(state, data) {
    state.locations = data
  },

  SET_LOCATIONS_BATCH_JOB(state, data) {
    state.locationsBatchJob = data
  },

  SET_BATCH_JOB_VALIDATION_ERRORS(state, data) {
    state.batchJobValidationErrors = data
  },

  SET_CLEAR_VALIDATION_ERRORS(state) {
    state.batchJobValidationErrors = {}
  }
};

const actions = {
  fetchLocations({ state, commit }, params) {
    return locationBatchJobsService.get(params).then((res) => {
      commit('SET_LOCATIONS', res.data);
    });
  },

  startBatchJob({ state, commit }, params) {
    return locationBatchJobsService
      .startBatchJob(params)
      .then((res) => {
        commit('SET_LOCATIONS_BATCH_JOB', res.data)
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('batch_job.started'))
      })
      .catch((err) => {
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('batch_job.failed_start'))
        throw err;
      })
  },

  endBatchJob({ state, commit }, params) {
    return locationBatchJobsService
      .endBatchJob(params)
      .then((res) => {
        commit('SET_LOCATIONS_BATCH_JOB', null)
      })
      .catch((err) => {
        commit('SET_BATCH_JOB_VALIDATION_ERRORS', mapErrorsToInputs(err))
        window.scrollTo(0, 0);
        throw err;
      })
  },

  fetchActiveBatchJob({ state, commit }, params) {
    return locationBatchJobsService
      .getActiveBatchJob(params)
      .then((res) => {
        if (res.data.id) {
          commit('SET_LOCATIONS_BATCH_JOB', res.data)
        }
      })
  },

  clearValidationErrors({ state, commit }) {
    commit('SET_CLEAR_VALIDATION_ERRORS')
  }

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
